module.exports = __webpack_public_path__ + "static/fulfillment-booking@3x-607f457cea5f2a1ad6e84c8df2539f4e.png";